<template>
  <aside class="tools-sidebar">
    <section class="tools-shell">
      <!-- Header -->
      <div class="tools-header">
        <div class=" w-10 h-10 p- bg-purple-100 rounded-full text-center "> 
                      <i class="fas fa-toolbox text-xl text-base text-purple-600 pt-1" title="Overview"></i>
                    </div>

        <h2>Tools</h2>
      </div>

      <!-- Lesson tools -->
      <section class="scope-card scope-card--lesson" v-if="hasValidLesson">
        <div class="scope-card__header">
          <div class="scope-title-row">
            <h3>LESSON TOOLS</h3>

            <span class="scope-pill">
              {{ lesson.name }}
            </span>
          </div>

          <p>Tools for this lesson only.</p>
        </div>

        <div class="tool-list">
          <button
            v-for="tool in lessonTools"
            :key="tool.id"
            type="button"
            class="tool-row"
            @click="emitTool(tool.id)"
          >
            <span
              class="tool-icon"
              :class=" 'text-' + tool.tone + '-500'"
            >
               <i class="fas" :class="'fa-' + tool.icon"></i>
            </span>

            <span class="tool-copy">
              <strong>{{ tool.label }}</strong>
              <span>{{ tool.description }}</span>
            </span>

          <i class="fas fa-chevron-right opacity-50"></i>

          </button>
        </div>

      </section>

      <!-- Unit tools -->
      <section class="scope-card scope-card--unit">
        <div class="scope-card__header">
          <div class="scope-title-row">
            <h3>UNIT TOOLS</h3>

            <span class="scope-pill scope-pill--unit">
              {{ course.name }}
            </span>
          </div>

          <p>Tools that apply to the whole unit.</p>
        </div>


        <transition name="slide-fade">
          <div
            class="tool-list unit-tool-list"
          >
            <button
              v-for="tool in unitTools"
              :key="tool.id"
              type="button"
              class="tool-row tool-row--compact"
              @click="emitTool(tool.id)"
            >
                <span
              class="tool-icon"
              :class=" 'text-' + tool.tone + '-500'"
            >
               <i class="fas" :class="'fa-' + tool.icon"></i>
            </span>

              <span class="tool-copy">
                <strong>{{ tool.label }}</strong>
                <span>{{ tool.description }}</span>
              </span>

          <i class="fas fa-chevron-right opacity-50"></i>
            
            </button>
          </div>
        </transition>
      </section>

      <!-- Help -->
      <section class="help-card">
        <div class="help-content">
          <h3>  <i class="fas fa-question-circle text-xl pr-1"></i> Need help?</h3>

          <p>
            Visit our Help Centre for guides,
            videos and support articles.
          </p>

          <button
            type="button"
            class="help-button"
            @click="$emit('help')"
          >
            Go to Help Centre

             <i class="fas fa-external-link-alt"></i>
          </button>
        </div>
      </section>
    </section>
  </aside>
</template>

<script>

export default {
  name: 'ToolsSidebar',

  props: {
      course: { type: Object, required: true },
      lesson: Object
  },
  computed: {
    hasValidLesson() {
      return this.lesson != undefined;
    },
  },

  data: function () {
    return {
      unitTools: [
        {
          id: 'assessment',
          label: 'Start Assessment',
          description: 'Create and manage assessments',
          icon: 'check-square',
          tone: 'red'
        },
        {
          id: 'outcomes',
          label: 'View Outcomes',
          description: 'See unit learning outcomes',
          icon: 'dot-circle',
          tone: 'blue'
        },
        {
          id: 'wellbeing',
          label: 'Pupil Voice',
          description: 'Capture pupil voice and opinions',
          icon: 'comments',
          tone: 'yellow'
        },
                {
          id: 'resources',
          label: 'Unit Resources',
          description: 'Materials across the whole unit',
          icon: 'folder',
          tone: 'orange'
        },
      ],

      lessonTools: [
                     {
          id: 'files',
          label: 'Lesson Files',
          description: 'Lesson resources and files',
          icon: 'file',
          tone: 'orange'
        },
                {
          id: 'evidence',
          label: 'Evidence',
          description: 'Capture pupil and lesson evidence',
          icon: 'images',
          tone: 'green'
        },
        {
          id: 'attendance',
          label: 'Take Attendance',
          description: 'Record and manage attendance',
          icon: 'calendar',
          tone: 'brown'
        },
                {
          id: 'feedback',
          label: 'Feedback / Notes',
          description: 'Add and view lesson feedback',
          icon: 'comment-alt',
          tone: 'purple'
        },
      ]
    }
  },

  methods: {
    emitTool: function (id) {
      this.$emit(id)
    }
  }
}
</script>

<style scoped>
.tools-sidebar {
  width: 95%;
}

.tools-shell {
  padding: 17px 16px 26px;  
}

.tools-shell {
  @apply border border-gray-200 bg-white rounded-lg;
}

/* Header */

.tools-header {
  display: flex;
  align-items: center;
  gap: 10px;

  margin: 0 12px 16px;
}

.tools-header__icon {
  width: 47px;
  height: 47px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
}


.tools-header h2 {
  margin: 0;

  color: var(--navy);

  font-size: 20px;
  font-weight: 750;
}

/* Scope cards */

.scope-card {
  padding: 17px 13px 13px;

  border-radius: 14px;

  background: linear-gradient(
    145deg,
    #faf9ff 0%,
    #f6f4ff 100%
  );
}

.scope-card + .scope-card {
  margin-top: 10px;
}

.scope-card__header {
  padding: 0 7px;
  margin-bottom: 11px;
}

.scope-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.scope-title-row h3 {
  margin: 0;

  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.015em;
}

.scope-title-row h3  {
 @apply text-blue-600
}

.scope-card--unit .scope-title-row h3  {
 @apply text-purple-600
}

.scope-card__header p {
  margin: 5px 0 0;

  color: #4e5872;

  font-size: 13px;
  line-height: 1.35;
}

.scope-pill {
  padding: 4px 9px;

  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
}

.scope-pill {
 @apply bg-blue-200 text-blue-400
}

.scope-pill--unit {
  @apply bg-purple-200 text-purple-400
}

/* Tools */

.tool-list {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.tool-row {
  width: 100%;

  display: flex;
  align-items: center;
  gap: 12px;

  padding: 11px 12px;

  border: 1px solid var(--border);
  border-radius: 10px;

  background: #fff;

  text-align: left;

  cursor: pointer;

  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease,
    transform 0.15s ease;
}

.tool-row:hover {
  transform: translateY(-1px);

  border-color: #d8dbe7;

  box-shadow: 0 5px 16px rgba(26, 34, 68, 0.06);
}

.tool-icon {
  flex: 0 0 37px;

  width: 37px;
  height: 37px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 9px;
}

.tool-icon {
 @apply text-2xl;
}

.tool-copy {
  min-width: 0;

  flex: 1;

  display: flex;
  flex-direction: column;
  gap: 3px;
}

.tool-copy strong {
  color: var(--navy);

  font-size: 13px;
  font-weight: 750;
}

.tool-copy span {
  color: var(--muted);

  font-size: 11.5px;
  line-height: 1.3;
}

.chevron {
  flex: 0 0 17px;

  width: 17px;
  height: 17px;

  color: #56647d;
}

/* Help */

.help-card {
  margin-top: 20px;
  padding: 22px 18px;

  display: flex;
  align-items: center;
  gap: 18px;

  border-radius: 13px;

}

.help-card {
    @apply border border-gray-200 rounded-lg;
}

.help-content {
  min-width: 0;
  flex: 1;
}

.help-content h3 {
  margin: 0 0 8px;

  color: var(--purple-dark, #4024b6);

  font-size: 15px;
  font-weight: 800;
}

.help-content p {
  margin: 0 0 14px;

  color: #202941;

  font-size: 12px;
  line-height: 1.45;
}

.help-button {
  display: inline-flex;
  align-items: center;
  gap: 9px;

  padding: 9px 13px;

  background: #fff;

  font-size: 12px;
  font-weight: 700;

  cursor: pointer;
}

.help-button {
    @apply text-purple-600 border border-purple-300 rounded-lg
}

.help-button:hover {
  @apply opacity-75
}

.help-button svg {
  width: 15px;
  height: 15px;
}

/* Improve feedback */

.improve-link {
  margin: 18px 16px 0;
  padding: 5px 0;

  display: inline-flex;
  align-items: center;
  gap: 8px;

  border: 0;

  color: var(--purple);
  background: transparent;

  font-size: 12px;
  font-weight: 700;

  cursor: pointer;
}

.improve-link:hover span {
  text-decoration: underline;
}

.improve-link svg {
  width: 18px;
  height: 18px;
}

/* Vue transition */

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition:
    opacity 0.18s ease,
    transform 0.18s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}

@media (max-width: 480px) {
  .tools-shell {
    padding: 16px 12px 20px;
  }

  .help-card {
    align-items: flex-start;
  }

  .help-graphic {
    flex-basis: 70px;
    transform: scale(0.82);
    transform-origin: top left;
  }
}
</style>